<template>
  <div class="dividend-transfer">
    <MoreTitle title="分红送转" @click="goPage" />
    <RkTable class="dividend-table" :data="eventList" :loading="loading" :finished="finished" :showFooter="false">
      <RkTableColumn prop="paymentDate" label="派息日" align="left" :width="`${postcssPatch(130)}`">
        <template #default="{ row }">{{
          $digitjs(row[market === 'hs' ? 'bonusDate' : 'paymentDate']).isNull()
        }}</template>
      </RkTableColumn>
      <RkTableColumn prop="plan" label="分配方案" align="left">
        <template #default="{ row }">{{ $digitjs(row.plan).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="exDate" label="除净日" :width="`${postcssPatch(130)}`">
        <template #default="{ row }">{{ $digitjs(row.exDate).isNull() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  name: 'DividendTransfer',
  data() {
    return {
      loading: false,
      finished: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    goPage() {
      this.$router.push({
        path: '/f10/behavior',
        query: {
          symbol: this.$route.query.symbol
        }
      })
    },
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-dividends', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data?.slice(0, 5) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dividend-transfer {
  background: var(--bg-color-2);
}

.dividend-table {
  --table-tbody-font-size: 14px;
}
</style>
